var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16749_178987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 1.72278V3.57926C16 3.63638 15.9752 3.6935 15.9256 3.7392L11.3072 9.00589V17.2772C11.3072 17.3629 11.2515 17.4372 11.1709 17.4772C11.1399 17.4943 11.1027 17.5 11.0655 17.5C11.0097 17.5 10.9601 17.4829 10.9167 17.4543L7.2964 14.8095C7.24061 14.7695 7.19721 14.7067 7.19721 14.6382V9.01732L0.068191 3.75062C0.024797 3.71064 0 3.65352 0 3.59068V1.72278C0 1.60282 0.105387 1.5 0.241769 1.5H15.7582C15.8946 1.5 16 1.60282 16 1.72278Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16749_178987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.38152ebf31a22d9fa6af60abdf10d9c2.svg";
export { ForwardRef as ReactComponent };